import { SERVICES } from "../data/mockData";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Terminal, Cpu, Network, Hexagon, Check, ArrowRight } from "lucide-react";

const ICONS = { Terminal, Cpu, Network, Hexagon };

export default function Services() {
  const services = SERVICES;


  return (
    <div className="fade-up" data-testid="page-services">
      {/* Header */}
      <section className="relative pt-16 pb-16 border-b border-[#1E2BFF]/20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="overline mb-5">// CAPABILITIES.FULL_INDEX</div>
          <h1 className="font-hero text-5xl lg:text-8xl font-black uppercase tracking-tighter text-white leading-[0.95]">
            Systems we <br />
            <span className="text-[#00F0FF] glow-cyan">operate.</span>
          </h1>
          <p className="mt-8 max-w-2xl text-[#9BA1D6] text-lg leading-relaxed">
            Four production-grade practice areas. Each with its own research
            agenda, reference architecture, and track record in the wild.
          </p>
        </div>
      </section>

      {/* Service sections */}
      <section className="relative">
        {services.map((s, idx) => {
          const Icon = ICONS[s.icon] || Terminal;
          const reverse = idx % 2 === 1;
          return (
            <motion.div
              key={s.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6 }}
              className="border-b border-[#1E2BFF]/20 scan-sweep"
              data-testid={`service-block-${s.id}`}
            >
              <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
                <div
                  className={`lg:col-span-5 ${reverse ? "lg:order-2" : ""
                    }`}
                >
                  <div className="hud-card corner-brackets tilt-card scan-sweep p-8">
                    <div className="flex items-center justify-between">
                      <div className="overline">// {s.tag}</div>
                      <Icon size={28} className="text-[#00F0FF]" strokeWidth={1.2} />
                    </div>
                    <div className="mt-10 font-mono text-[10px] tracking-[0.28em] text-[#9BA1D6] uppercase space-y-2">
                      <div className="flex justify-between border-b border-dashed border-[#1E2BFF]/25 pb-2">
                        <span>Stage</span><span className="text-white">RESEARCH → SHIP</span>
                      </div>
                      <div className="flex justify-between border-b border-dashed border-[#1E2BFF]/25 pb-2">
                        <span>Avg Timeline</span><span className="text-white">8-16 wks</span>
                      </div>
                      <div className="flex justify-between border-b border-dashed border-[#1E2BFF]/25 pb-2">
                        <span>Deliverables</span><span className="text-white">Code + Docs + Runbook</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Classification</span><span className="text-[#00F0FF]">PRODUCTION</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`lg:col-span-7 ${reverse ? "lg:order-1" : ""}`}>
                  <div className="overline mb-4">// {s.tag}</div>
                  <h2 className="font-display text-3xl lg:text-6xl font-bold tracking-tighter text-white leading-[1]">
                    {s.title}
                  </h2>
                  <p className="mt-6 text-[#9BA1D6] text-lg leading-relaxed max-w-2xl">
                    {s.description}
                  </p>
                  <div className="mt-10 grid sm:grid-cols-2 gap-3">
                    {s.capabilities.map((c) => (
                      <div
                        key={c}
                        className="flex items-start gap-3 border border-[#1E2BFF]/25 p-4 bg-[#05060F]/50"
                      >
                        <Check size={16} className="text-[#00F0FF] mt-0.5" />
                        <span className="text-sm text-white/90">{c}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </section>

      {/* CTA */}
      <section className="relative py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="hud-card corner-brackets p-10 lg:p-16 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            <div>
              <div className="overline mb-4">// NEXT.STEP</div>
              <h3 className="font-display text-3xl lg:text-5xl font-bold text-white tracking-tighter">
                Have a system to <span className="text-[#00F0FF] glow-cyan">build?</span>
              </h3>
            </div>
            <Link to="/contact" className="btn-primary" data-testid="services-cta-contact">
              Start a Project <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
